import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectLocale } from "../../store/slices/preferences";

const CLDate = ({ date }) => {
  const locale = useSelector(selectLocale);
  const dateObject = new Date(date);
  const formattedDate = dateObject.toLocaleDateString(locale);

  return formattedDate;
};

CLDate.propTypes = {
  date: PropTypes.string.isRequired,
};

export default CLDate;
